import React, { ReactElement, useContext } from 'react'
// Commons imports.
import Icon, { IconName } from '../../Common/Components/Icon'
// Contexts imports.
import { LanguageContext } from '../../Common/Contexts'
// Utilities imports.
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { LanguageBulkInsertUsers } from '../../../../i18n'
import { EmailErrorGeneric } from '../../Common/Types/Types'
import { ExpansionPanelItem } from '../../Common/Components/ExpansionPanel'
import BulkInsertExpansionPanel from '../BulkInsertExpansionPanel'
// CSS imports. Commented out because of current build process.
// import './resultStep.scss';

/**
 * Component properties type.
 */
type Props = {
    emailErrors: Map<number, EmailErrorGeneric[]>
}

/**
 * Success slide for bulk importing users.
 */
const ResultStep: React.FC<Props> = ({ emailErrors }: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler

    const isEmailSendingErrored = emailErrors.size > 0

    // Define expansion panel error items from errors.
    const expansionPanelErrorItems: ExpansionPanelItem[] = Array.from(emailErrors).map(([, value]) => ({
        title: (
            <div className='expansion-panel-header'>{`${language.get(
                LanguageBulkInsertUsers.UploadfilesEmailserroredsendingseebelow
            )}`}</div>
        ),
        content: (
            <div>
                {value.map((error: EmailErrorGeneric, index: number) => (
                    <div key={`${error.ErrorCode}${index}`} className='cErrorContent'>
                        <span>User {error.UserID}:</span>
                        <span>{` ${error.ErrorMessage}`}</span>
                    </div>
                ))}
            </div>
        )
    }))

    return (
        <div className='result-step'>
            {!isEmailSendingErrored ? (
                <React.Fragment>
                    <div className='successful-icon'>
                        <Icon iconName={IconName.SUCCESS} />
                    </div>
                    <div className='successful-para'>
                        <p>
                            {language.get(LanguageBulkInsertUsers.LanguageBulkInsertUsers_UploadfilesSuccessparagraph1)}
                        </p>
                    </div>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <div className='warning-icon'>
                        <Icon iconName={IconName.ERRORCIRCLE} />
                    </div>
                    <div className='warning-para'>
                        <p className='gutter-bottom'>
                            {language.get(LanguageBulkInsertUsers.UploadfilesSuccesswitherrorparagraph)}
                        </p>
                        <React.Fragment>
                            <BulkInsertExpansionPanel expansionPanelItems={expansionPanelErrorItems} />
                        </React.Fragment>
                    </div>
                </React.Fragment>
            )}
        </div>
    )
}

export default ResultStep
